<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import {
  use
} from "echarts/core";
import {
  CanvasRenderer
} from "echarts/renderers";
import {
  PieChart
} from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";

import { getIndestryInfo } from "@/api/api.js";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);
var data = [{
    value: 24.2,
    num: 53,
    name: "参加商户数"
  },
  {
    value: 75.8,
    num: 166,
    name: "商户总数"
  }
]
export default {
  components: {},
  data() {
    return {
      option: {
        legend: {
          type: "plain",
          orient: "vertical",
          right: "5%",
          top: "10%",
          textStyle: {
            color: "#a3fffe",
            fontSize: "16",
          },
          itemHeight: 12,
          itemWidth: 12,
          itemGap: 20,
          formatter: (name) => {
            const item = data.find((_item) => {
              return _item.name == name
            })
            return  name + '  ' + item.num
          }
        },
        tooltip: {
          trigger: "item",
        },
        series: [{
          name: "活动数占比",
          type: "pie",
          radius: [40, 70],
          center: ["40%", "40%"],
          roseType: "area",

          data: data,
          
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: '{c}%'
              }
            }
          },
          left: "0%",
        }, ],
      },
    };
  },
  methods: {
    getData() {
      getIndestryInfo().then((res) => {
        this.option.series[0].data = res.data.data.map((o) => {
          return {name: o.type_name, value: o.percent}
        }).slice(0, 8)
      });
    },
  },
  mounted() {
    this.getData()
    this.timer = setInterval(this.getData, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
};
</script>

<style scoped></style>
